module.exports = {
  emptyMessage: 'Kartta göründüğü gibi ismi tamamlayın',
  containsNumberMessage: 'İsim rakam içeremez',
  maxLengthMessage: 'İzin verilen karakter sayısını aştınız, lütfen tekrar doldurun.',
  defaultMessage: 'Geçersiz isim.',
};
